import type { AdvisorySourceReferenceV01 } from './advisoryProvenance';

export interface AdvisorySourcePassageRequest {
  documentId: string;
  chunkId: string;
  collectionIds: readonly string[];
}

export type AdvisorySourcePassageResult =
  | { status: 'ready'; text: string; pageRange: readonly [number, number] | null }
  | { status: 'denied' | 'missing' | 'unavailable' | 'failed' | 'invalid' };

export type AdvisorySourcePassageLoader = (
  request: AdvisorySourcePassageRequest,
  signal: AbortSignal
) => Promise<AdvisorySourcePassageResult>;

const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Scope a document read to the stored memberships. Access is decided by gmid. */
export function sourcePassageRequest(
  source: AdvisorySourceReferenceV01
): AdvisorySourcePassageRequest | null {
  if (
    source.kind !== 'document' ||
    source.origin === 'computed' ||
    !source.documentId ||
    !uuid.test(source.documentId) ||
    !source.chunkId ||
    !source.collectionIds?.length ||
    !source.collectionIds.every(id => uuid.test(id))
  )
    return null;
  return {
    documentId: source.documentId,
    chunkId: source.chunkId,
    collectionIds: source.collectionIds,
  };
}
